'use client';

import { useState } from 'react';

type TabHeaderContainer = {
  className?: string;
  rel?: string;
  content: React.ReactNode;
};

type TabContentContainer = {
  className?: string;
  content: React.ReactNode;
};

type TabProps = {
  className: string;
  headerClassName?: string;
  contentClassName?: string;
  headerContainers: TabHeaderContainer[];
  contentContainers: TabContentContainer[];
};

export function TabComponent(props: TabProps) {
  const [currentTab, setCurrentTab] = useState('0');

  const handleTabClick = (e: any) => {
    setCurrentTab(e.target.id);
  };

  return (
    <div className={props.className}>
      <div className={props.headerClassName}>
        {props.headerContainers.map((item, index: number) => (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <a
            key={index}
            id={`${index}`}
            className={item.className}
            rel={item.rel}
            style={{
              width: 'auto',
              display: 'inline-block',
            }}
            onClick={handleTabClick}
          >
            {item.content}
          </a>
        ))}
      </div>
      <div className={props.contentClassName}>
        {props.contentContainers.map((child, childIndex: number) => (
          <div
            key={childIndex}
            className={child.className}
            style={{
              overflow: 'hidden',
              height: '100%',
              display: `${currentTab === `${childIndex}` ? 'block' : 'none'}`,
            }}
          >
            {child.content}
          </div>
        ))}
      </div>
    </div>
  );
}

export default TabComponent;
